<template>
  <h1>News Content Layout</h1>
</template>